import React, { useEffect, useState } from 'react';
import { LazyComponent } from '@fiverr-private/orca';
import { Modal, ModalTrigger } from '@fiverr-private/overlay';
import { sendBigQuery } from '../../utils/biEventsTracking';
import {
    BI_EVENT_SELLER_INFO_DISPLAY_CLICKED_ON_ENTRY_POINT,
    BI_EVENT_SELLER_INFO_DISPLAY_MORE_INFO_IS_SHOWN,
} from '../../utils/biEventsTracking/constants';
import { TraderDetailsModalTriggerProps } from './types';

const lazyImport = () => import(/* webpackChunkName: 'TraderDetailsModalContent' */ '../TraderDetailsModalContent');

export const TraderDetailsModalTrigger = ({
    sellerId,
    sellerName,
    showCaptcha,
    children,
}: TraderDetailsModalTriggerProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [modalImported, setModalImported] = useState(false);

    useEffect(() => {
        sendBigQuery(BI_EVENT_SELLER_INFO_DISPLAY_MORE_INFO_IS_SHOWN);
    }, []);

    const openModal = () => {
        setIsOpen(true);
    };

    const onClose = () => {
        setIsOpen(false);
    };

    const onClick = async (e) => {
        e.preventDefault();
        sendBigQuery(BI_EVENT_SELLER_INFO_DISPLAY_CLICKED_ON_ENTRY_POINT);

        if (modalImported) {
            openModal();
            return;
        }

        setModalImported(true);
        openModal();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalTrigger>
                <span onClick={onClick}>{children}</span>
            </ModalTrigger>
            {modalImported && (
                <LazyComponent
                    lazyImport={lazyImport}
                    componentProps={{
                        sellerId,
                        sellerName,
                        showCaptcha,
                    }}
                />
            )}
        </Modal>
    );
};
